import React, { Component } from "react";
import { connect } from "react-redux";
import { Translate } from "react-localize-redux";
import Grid from "@material-ui/core/Grid";
import Card from "@material-ui/core/Card";
import CardActions from "@material-ui/core/CardActions";
import CardContent from "@material-ui/core/CardContent";
import Button from "@material-ui/core/Button";
import TextField from "@material-ui/core/TextField";
import Checkbox from "@material-ui/core/Checkbox";
import FormControlLabel from "@material-ui/core/FormControlLabel";
import { getTranslate } from "react-localize-redux";
import {
  toggleConfigurationMode,
  saveConfiguration
} from "../redux/actions/configurationActions";
import { getState } from "../redux/thunks/orderThunks";
import { signalRStart } from "../middleware/signalRMiddleware";

class SettingsContainer extends Component {
  componentWillMount = () => {
    this.setState({
      kitchenServiceAddress: this.props.kitchenServiceAddress,
      showPreparationView: this.props.showPreparationView,
      showReadyToPickUpView: this.props.showReadyToPickUpView
    });
  };

  handleChange = name => event => {
    this.setState({
      [name]: event.target.value
    });
  };

  handleCheckBoxChange = name => event => {
    this.setState({
      [name]: event.target.checked
    });
  };

  submitForm = () => {
    if (Object.keys(this.state).some(key => this.state[key] === "")) {
      return;
    }

    this.props.saveConfiguration(this.state);
    signalRStart();
  };

  refresh = () => {
    this.props.toggleConfigurationMode();
    this.props.getState();
  };

  render() {
    if (this.state == null) {
      return <div />;
    }

    return (
      <div className="flex-container">
        <div className="flexbox-centered-element w-100">
          <form autoComplete="off">
            <Card className="display-card">
              <CardContent>
                <div className="title">
                  <Translate id="DisplaySettings" />
                </div>
                <Grid container spacing={24}>
                  <Grid item xs={12} sm={12}>
                    <TextField
                      required
                      id="kitchenServiceAddress"
                      name="kitchenServiceAddress"
                      label={this.props.translate("kitchenServiceAddress")}
                      value={this.state.kitchenServiceAddress}
                      onChange={this.handleChange("kitchenServiceAddress")}
                      error={this.state.kitchenServiceAddress === ""}
                      placeholder={this.props.translate("ServicePlaceholder")}
                      fullWidth
                      margin="normal"
                    />
                  </Grid>
                  <Grid item xs={12} sm={12}>
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.showPreparationView}
                          onChange={this.handleCheckBoxChange(
                            "showPreparationView"
                          )}
                        />
                      }
                      label={this.props.translate("showPreparationView")}
                    />
                    <FormControlLabel
                      control={
                        <Checkbox
                          checked={this.state.showReadyToPickUpView}
                          onChange={this.handleCheckBoxChange(
                            "showReadyToPickUpView"
                          )}
                        />
                      }
                      label={this.props.translate("showReadyToPickUpView")}
                    />
                  </Grid>
                </Grid>
              </CardContent>
              <CardActions className="button-panel">
                <Button
                  color="secondary"
                  variant="contained"
                  onClick={this.props.toggleConfigurationMode}
                >
                  <Translate id="Cancel" />
                </Button>
                <Button
                  variant="contained"
                  className="refresh-button"
                  onClick={this.refresh}
                >
                  <Translate id="Refresh" />
                </Button>

                <Button
                  variant="contained"
                  className="save-button"
                  onClick={this.submitForm}
                >
                  <Translate id="Save" />
                </Button>
              </CardActions>
            </Card>
          </form>
        </div>
      </div>
    );
  }
}

function mapStateToProps(state, ownProps) {
  return {
    translate: getTranslate(state.localize),
    showPreparationView: state.configuration.showPreparationView,
    showReadyToPickUpView: state.configuration.showReadyToPickUpView,
    kitchenServiceAddress: state.configuration.kitchenServiceAddress
  };
}

function mapDispatchToProps(dispatch) {
  return {
    toggleConfigurationMode: () => dispatch(toggleConfigurationMode()),
    getState: () => dispatch(getState()),
    saveConfiguration: address => dispatch(saveConfiguration(address))
  };
}

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(SettingsContainer);



// WEBPACK FOOTER //
// ./src/containers/SettingsContainer.js